import { useContext } from 'react'
import { useQuery, useSubscription } from '@apollo/client'
import { AuthContext } from '@/context/auth-context'
import { GET_UNREAD_NOTIFICATIONS_COUNT, NOTIFICATION_RECEIVED } from '@/graphql/notification-queries'
import useNotificationsStore from '@/store/notificationsStore'

export const useNotificationsSubscription = () => {
    const { user } = useContext(AuthContext)
    const setUnreadCount = useNotificationsStore((s) => s.setUnreadCount)
    const incrementUnread = useNotificationsStore((s) => s.incrementUnread)

    useQuery(GET_UNREAD_NOTIFICATIONS_COUNT, {
        variables: { userId: user?.id },
        skip: !user?.id,
        fetchPolicy: 'network-only',
        onCompleted: (data) => {
            if (typeof data?.getUnreadNotificationsCount === 'number') {
                setUnreadCount(data.getUnreadNotificationsCount)
            }
        },
    })

    useSubscription(NOTIFICATION_RECEIVED, {
        variables: { userId: user?.id },
        skip: !user?.id,
        onData: ({ data }) => {
            if (data?.data?.notificationReceived) {
                incrementUnread()
            }
        },
        onError: (error) => {
            console.error('Notification subscription error:', error)
        },
    })
}
